import * as marietta from '../../..';
import * as marietta3d from '../../../../marietta3d';
import {ModelLoadSystem} from '../../../view3d/webcad/WebCad3dModelLoadSystem';

export default class RoofShapeMenu {
    data: marietta3d.AutoGen.ConstructionModel;

    viewObj: HTMLElement;

    directionIcon: HTMLElement;

    // 東西南北  = 51,52,53,54
    DIRECTION_E: number = 51;

    DIRECTION_W: number = 52;

    DIRECTION_S: number = 53;

    DIRECTION_N: number = 54;

    angle: number;

    slopeDirection: number = this.DIRECTION_E;

    MIN_NOKIDE = {
      yosemune: 0,
      yokogiri: 0,
      tategiri: 0,
      katanagare: 0,
    }

    MAX_NOKIDE = {
      yosemune: 999,
      yokogiri: 999,
      tategiri: 999,
      katanagare: 999,
    }

    MIN_TSUMADE = {
      yosemune: 0,
      yokogiri: 0,
      tategiri: 0,
      katanagare: 0,
    }

    MAX_TSUMADE = {
      yosemune: 999,
      yokogiri: 999,
      tategiri: 999,
      katanagare: 999,
    }

    MIN_KOUBAI = {
      yosemune: 0.1,
      yokogiri: 0.1,
      tategiri: 0.1,
      katanagare: 0.1,
    }

    MAX_KOUBAI = {
      yosemune: 10,
      yokogiri: 10,
      tategiri: 10,
      katanagare: 10,
    }

    /**
     * コンストラクタ
     */
    constructor() {
      this.viewObj = document.getElementById('tabRoofShape');
      this.directionIcon = document.querySelector('#roofDirectionController .roofDirection');
      document.querySelectorAll('.tabTrigger').forEach((element) => {
        element.addEventListener('click', this.onChangeTab);
      });
      // 情報をGET
      this.data = marietta.webcad.WebCADGlobal.autoMain.Model;

      const self = this;
      document.getElementById('btnChangeRoofShape').addEventListener('click', self.okBtnEventHandler);
      // document.getElementById('btnChangeRoofShape').addEventListener('click', self.init);
      document.querySelectorAll('#tabRoofShape input[type="number"]').forEach((inputElement: HTMLElement) => {
        inputElement.addEventListener('change', self.inputChangeEventHandler);
      });
      document.getElementById('roofDirectionController').addEventListener('click', self.changeDirectionControlHandler);
    }

    /**
     * 初期設定
     */
    init = () => {
      console.log('init');

      // 片流れの方角をリセット
      const list: string[] = RoofShapeMenu.arrangeRoofType(Number(this.data.AutoRoof.roofType));
      this.slopeDirection = list.length < 2 ? this.DIRECTION_E : Number(this.data.AutoRoof.roofType);

      // タブの表示を更新
      this.updateTab();

      // パラメータの表示を更新
      this.updateParam();

      // 値を制限
      this.restrictParamAll();
    }

    /**
     * OKボタンが押された
     */
    okBtnEventHandler = () => {
      // 変更の実行
      this.executeRoofChange();
    }

    /**
     * 屋根変更の実行
     */
    executeRoofChange(): void {
      // 実行
      marietta.webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();

      const self = this;
      // [3D] ConstructionModelに反映
      marietta.webcad.WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_PREPARING_DATA'), () => {
        setTimeout(() => {
          self.setParamConstructionModel();
        }, 500);
      });

      // 変更フラグを立てる
      marietta.webcad.WebCADGlobal.webcad2Dmanager.isChanged = true;
    }

    /**
     * inputの数値が変更された
     */
    inputChangeEventHandler = (e) => {
      const target = e.currentTarget;
      this.restrictParam(target);
    }

    private timeoutID;

    /**
     * 屋根方向矢印アイコンがクリックされた
     */
    changeDirectionControlHandler = () => {
      const self = this;

      // 連打された場合キャンセルするs
      clearTimeout(this.timeoutID);
      this.timeoutID = setTimeout(() => {
        // 90度回転させる
        self.angle += 90;
        // 元の方角から角度を取得
        const num: number = self.convertAngleToDirection(self.angle);
        //                var angle:number = self.convertDirectionToAngle(self.slopeDirection);
        //                if(angle >= a)
        // deg = `rotateZ(${self.angle}deg)`;
        self.directionIcon.style.transform = `rotate(${self.angle}deg)`;

        // num = self.convertAngleToDirection(self.angle);
        self.setSlopeDirection(num);
      }, 200);
    }

    /**
     * 片流れ方向を保持する
     */
    setSlopeDirection(num: number) {
      this.slopeDirection = num;
    }

    /**
     * 片流れ方向を角度に変換する
     */
    convertDirectionToAngle(directionNumber: number): number {
      switch (directionNumber) {
        case this.DIRECTION_N: return 0;
        case this.DIRECTION_E: return 90;
        case this.DIRECTION_S: return 180;
        case this.DIRECTION_W: return 270;
        default: return 0;
      }
    }

    /**
     * 角度を片流れ方向に変換する
     */
    convertAngleToDirection(angle: number): number {
      switch ((angle % 360)) {
        case 0: return this.DIRECTION_N;
        case 90: return this.DIRECTION_E;
        case 180: return this.DIRECTION_S;
        case 270: return this.DIRECTION_W;
        default: return this.DIRECTION_E;
      }
    }

    /**
     * roofTypeの値を整理
     */
    static arrangeRoofType(roofType: number): string[] {
      const roofTypeStr = String(roofType);
      const retList = [];
      for (let i = 0, len = roofTypeStr.length; i < len; i += 1) {
        retList.push(roofTypeStr.charAt(i));
      }
      return retList;
    }

    onChangeTab = (e:Event) => {
      const target = (<HTMLElement>e.currentTarget).getAttribute('data-tabtrigger');
      (<HTMLElement> document.querySelector('.roofHorizontalEvesCheck')).style.display = 'block';
      if (target === '#tabContentRoofShapeFlat' || target === '#tabContentRoofShapeKatanagare') {
        (<HTMLElement> document.querySelector('.roofHorizontalEvesCheck')).style.display = 'none';
      }
    }

    /**
     * 値を制限する
     */
    restrictParam(target: HTMLElement) {
      const tarSetName: string = target.getAttribute('name');
      const tarTabName: string = target.closest('.tabContent').id;
      const inputElement: HTMLInputElement = (target as HTMLInputElement);
      let value = Number(inputElement.value) || 0;
      switch (tarTabName) {
        case 'tabContentRoofShapeYosemune':
          if (tarSetName === 'roof_nokide') {
            if (value > this.MAX_NOKIDE.yosemune) {
              value = this.MAX_NOKIDE.yosemune;
            } else if (value < this.MIN_NOKIDE.yosemune) {
              value = this.MIN_NOKIDE.yosemune;
            }
          } else if (tarSetName === 'roof_tsumade') {
            if (value > this.MAX_TSUMADE.yosemune) {
              value = this.MAX_TSUMADE.yosemune;
            } else if (value < this.MIN_TSUMADE.yosemune) {
              value = this.MIN_TSUMADE.yosemune;
            }
          } else if (tarSetName === 'roof_koubai') {
            if (value > this.MAX_KOUBAI.yosemune) {
              value = this.MAX_KOUBAI.yosemune;
            } else if (value < this.MIN_KOUBAI.yosemune) {
              value = this.MIN_KOUBAI.yosemune;
            }
          }
          break;
        case 'tabContentRoofShapeYokogiri':
          if (tarSetName === 'roof_nokide') {
            if (value > this.MAX_NOKIDE.yokogiri) {
              value = this.MAX_NOKIDE.yokogiri;
            } else if (value < this.MIN_NOKIDE.yokogiri) {
              value = this.MIN_NOKIDE.yokogiri;
            }
          } else if (tarSetName === 'roof_tsumade') {
            if (value > this.MAX_TSUMADE.yokogiri) {
              value = this.MAX_TSUMADE.yokogiri;
            } else if (value < this.MIN_TSUMADE.yokogiri) {
              value = this.MIN_TSUMADE.yokogiri;
            }
          } else if (tarSetName === 'roof_koubai') {
            if (value > this.MAX_KOUBAI.yokogiri) {
              value = this.MAX_KOUBAI.yokogiri;
            } else if (value < this.MIN_KOUBAI.yokogiri) {
              value = this.MIN_KOUBAI.yokogiri;
            }
          }
          break;
        case 'tabContentRoofShapeTategiri':
          if (tarSetName === 'roof_nokide') {
            if (value > this.MAX_NOKIDE.tategiri) {
              value = this.MAX_NOKIDE.tategiri;
            } else if (value < this.MIN_NOKIDE.tategiri) {
              value = this.MIN_NOKIDE.tategiri;
            }
          } else if (tarSetName === 'roof_tsumade') {
            if (value > this.MAX_TSUMADE.tategiri) {
              value = this.MAX_TSUMADE.tategiri;
            } else if (value < this.MIN_TSUMADE.tategiri) {
              value = this.MIN_TSUMADE.tategiri;
            }
          } else if (tarSetName === 'roof_koubai') {
            if (value > this.MAX_KOUBAI.tategiri) {
              value = this.MAX_KOUBAI.tategiri;
            } else if (value < this.MIN_KOUBAI.tategiri) {
              value = this.MIN_KOUBAI.tategiri;
            }
          }
          break;
        case 'tabContentRoofShapeKatanagare':
          if (tarSetName === 'roof_nokide') {
            if (value > this.MAX_NOKIDE.katanagare) {
              value = this.MAX_NOKIDE.katanagare;
            } else if (value < this.MIN_NOKIDE.katanagare) {
              value = this.MIN_NOKIDE.katanagare;
            }
          } else if (tarSetName === 'roof_tsumade') {
            if (value > this.MAX_TSUMADE.katanagare) {
              value = this.MAX_TSUMADE.katanagare;
            } else if (value < this.MIN_TSUMADE.katanagare) {
              value = this.MIN_TSUMADE.katanagare;
            }
          } else if (tarSetName === 'roof_koubai') {
            if (value > this.MAX_KOUBAI.katanagare) {
              value = this.MAX_KOUBAI.katanagare;
            } else if (value < this.MIN_KOUBAI.katanagare) {
              value = this.MIN_KOUBAI.katanagare;
            }
          }
          break;
        default: break;
      }

      inputElement.value = String(value);
    }

    /**
     * 全ての値を制限
     */
    restrictParamAll() {
      document.querySelectorAll('#tabRoofShape input[type="number"]').forEach((inputElement: HTMLElement) => {
        this.restrictParam(inputElement);
      });
    }

    /**
     * タブの表示を更新
     */
    updateTab() {
      let roofType: number;
      if (!this.data) return;

      roofType = Number(this.data.AutoRoof.roofType);
      // roofType番号の整理
      const list: string[] = RoofShapeMenu.arrangeRoofType(roofType);
      roofType = Number(list[0]);

      (document.querySelectorAll('.roofShapeTabmenu .tabTrigger')[roofType - 1] as HTMLElement).click();
    }

    /**
     * ダイアログに表示するパラメータを更新
     */
    updateParam() {
      if (!this.data) return;

      // 表示するパラメータを取得
      let nokideData = this.data.AutoRoof.nokide;
      if (Number.isNaN(this.data.AutoRoof.nokide) || this.data.AutoRoof.nokide == null) nokideData = 300;
      let tumadeData = this.data.AutoRoof.tumade;
      if (Number.isNaN(this.data.AutoRoof.tumade) || this.data.AutoRoof.tumade == null) tumadeData = 250;

      let slope = (Number(this.data.AutoRoof.slope) !== 0) ? this.data.AutoRoof.slope : 4.5;

      document.querySelectorAll('.nokideSet input[type="number"]').forEach((element: HTMLElement) => {
        const inputElement = (element as HTMLInputElement);
        inputElement.value = String(nokideData);
      });
      document.querySelectorAll('.tsumadeSet input[type="number"]').forEach((element: HTMLElement) => {
        const inputElement = (element as HTMLInputElement);
        inputElement.value = String(tumadeData);
      });
      document.querySelectorAll('.koubaiSet input[type="number"]').forEach((element: HTMLElement) => {
        const inputElement = (element as HTMLInputElement);
        inputElement.value = String(slope);
      });

      // 片流れの設定
      nokideData = this.data.AutoRoof.nokide;
      if (Number.isNaN(this.data.AutoRoof.nokide) || this.data.AutoRoof.nokide == null) nokideData = 150;
      tumadeData = (Number.isNaN(this.data.AutoRoof.tumade)) ? 150 : this.data.AutoRoof.tumade;
      if (Number.isNaN(this.data.AutoRoof.tumade) || this.data.AutoRoof.tumade == null) tumadeData = 150;

      slope = (Number(this.data.AutoRoof.slope) !== 0) ? this.data.AutoRoof.slope : 2;
      (document.querySelector('#tabContentRoofShapeKatanagare .nokideSet input[type="number"]') as HTMLInputElement).value = String(nokideData);
      (document.querySelector('#tabContentRoofShapeKatanagare .tsumadeSet input[type="number"]') as HTMLInputElement).value = String(tumadeData);
      (document.querySelector('#tabContentRoofShapeKatanagare .koubaiSet input[type="number"]') as HTMLInputElement).value = String(slope);

      // 片流れ方向の設定
      this.angle = this.convertDirectionToAngle(this.slopeDirection);
      this.directionIcon.style.transform = `rotate(${this.angle}deg)`;

      (<HTMLInputElement> document.getElementById('checkHorizontalEves')).checked = this.data.Option.suihei_nokiten;
    }

    /**
     * [3D] ConstructionModelに反映
     */
    setParamConstructionModel = () => {
      console.log(555);
      // 変更するパラメータを取得
      let roofType;
      let nokide;
      let tumade;
      let slope;
      const checkedTab = ([...document.querySelectorAll('.roofShapeTabmenu input[type="radio"]')].indexOf(document.querySelector('.roofShapeTabmenu input[type="radio"]:checked')) + 1);
      switch (checkedTab) {
        case 1: // 寄棟
          roofType = checkedTab;
          nokide = (document.querySelector('#tabContentRoofShapeYosemune .nokideSet input[type="number"]') as HTMLInputElement).value;
          // tumade = (document.querySelector('#tabContentRoofShapeYosemune .tsumadeSet input[type="number"]') as HTMLInputElement).value;
          slope = (document.querySelector('#tabContentRoofShapeYosemune .koubaiSet input[type="number"]') as HTMLInputElement).value;
          break;
        case 2: // 横切妻
          roofType = checkedTab;
          nokide = (document.querySelector('#tabContentRoofShapeYokogiri .nokideSet input[type="number"]') as HTMLInputElement).value;
          tumade = (document.querySelector('#tabContentRoofShapeYokogiri .tsumadeSet input[type="number"]') as HTMLInputElement).value;
          slope = (document.querySelector('#tabContentRoofShapeYokogiri .koubaiSet input[type="number"]') as HTMLInputElement).value;
          break;
        case 3: // 縦切妻
          roofType = checkedTab;
          nokide = (document.querySelector('#tabContentRoofShapeTategiri .nokideSet input[type="number"]') as HTMLInputElement).value;
          tumade = (document.querySelector('#tabContentRoofShapeTategiri .tsumadeSet input[type="number"]') as HTMLInputElement).value;
          slope = (document.querySelector('#tabContentRoofShapeTategiri .koubaiSet input[type="number"]') as HTMLInputElement).value;
          break;
        case 4: // フラット
          roofType = checkedTab;
          nokide = 0;
          tumade = 0;
          slope = 0;
          break;
        case 5: // 片流れ
          roofType = this.slopeDirection;
          nokide = (document.querySelector('#tabContentRoofShapeKatanagare .nokideSet input[type="number"]') as HTMLInputElement).value;
          tumade = (document.querySelector('#tabContentRoofShapeKatanagare .tsumadeSet input[type="number"]') as HTMLInputElement).value;
          slope = (document.querySelector('#tabContentRoofShapeKatanagare .koubaiSet input[type="number"]') as HTMLInputElement).value;
          break;
        default: break;
      }

      const horizontalEves = (<HTMLInputElement> document.getElementById('checkHorizontalEves')).checked;
      // パラメータをConstructionModelにセット
      this.data.AutoRoof.roofType = roofType;
      this.data.AutoRoof.nokide = nokide;
      this.data.AutoRoof.tumade = tumade;
      this.data.AutoRoof.slope = slope;
      this.data.Option.suihei_nokiten = horizontalEves;

      // 3Dのボタンの表示をデフォルトに戻す
      marietta.webcad.WebCADGlobal.init3dMenu();

      this.init();

      // //モデル再構築
      // var start3D = function(doc, x, y, data) {
      //     marietta.view3d.View3dGlobal.shared.resetScene();
      //     marietta.view3d.View3dGlobal.shared.show3D(doc, x, y, data);
      // }

      // 3D内観ビューのカメラ情報を保持
      marietta.view3d.webcad.View3dGlobal.shared.saveCameraState();
      // 屋根形状の変更を行った時に外観カメラ位置を保持しておき
      marietta.view3d.webcad.View3dGlobal.shared.keepCameraState = true;

      new ModelLoadSystem().request3D();

      // [2D] modelParamに反映
      this.setModelParamXML();

      // setが完了したらダイアログを閉じる
      marietta.webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();
    }

    /**
     * [2D] modelParamに反映
     */
    setModelParamXML() {
      const jsonData = this.data.writeJSON();
      marietta.webcad.WebCADGlobal.setModelParamFromConstructionModel(jsonData);
    }
}
